<script setup lang="ts">
type Props = {
    icon: string
}

const { icon } = defineProps<Props>()
</script>

<template>
    <li class="text-gray-600 flex items-center justify-center lg:justify-start">
        <i class="lni mr-3" :class="icon" aria-hidden="true"></i>
        <slot />
    </li>
</template>
